<template>
  <div class="home-view">
    <section class="slides">
      <swiper ref="swiperSlides" @slideChange="slideChanged()">
        <template>
          <swiper-slide
            v-for="(item, i) in data.vitrines"
            :key="i"
            :style="{ backgroundImage: `url(${urlFiles}cliente/vitrines/${item[isMobile() ? 'arteMobile' : 'arteDesktop']})` }"
          >
            <img :src="`${urlFiles}cliente/vitrines/${item[isMobile() ? 'arteMobile' : 'arteDesktop']}`" alt="">
          </swiper-slide>
        </template>
      </swiper>

      <ul class="bullets" v-if="data.vitrines && data.vitrines.length > 1">
        <li v-for="(item, i) in data.vitrines" :key="i">
          <a href="javascript:void(0)" @click="slideTo(i)" :class="{ '-active': activeIndex == i }"></a>
        </li>
      </ul>
    </section>

    <section class="level">
      <div class="container">
        <h2>Andamento do seu Fibra Experts</h2>
      </div>

      <div class="swiper-content">
        <div class="container">
          <div class="nav-container">
            <a
              href="javascript:void(0)"
              @click="slidePrevLevel()"
              class="icon -prev"
            />

            <a
              href="javascript:void(0)"
              @click="slideNextLevel()"
              class="icon -next"
              :class="{ '-deactivated': level.activeIndex == data.regua.length - 1 }"
            />
          </div>

          <swiper
            :options="level.options"
            ref="swiperLevel"
          >
            <div class="phases">
              <ul>
                <li v-for="(item,  i) in data.regua" :key="i"
                :class="{
                  'current-phase': item.current,
                  'phase-done': item.isCompleted
                  }">
                  <span v-if="item.id === data.etapaReguaId">Fase atual</span>
                </li>
              </ul>
            </div>

            <swiper-slide
              v-for="(item, i) in data.regua"
              :key="i"
              class="-slide"
              :class="{
                'current-phase': item.current,
                'phase-done': item.isCompleted,
              }"
            >
              <div class="step-image" :style="{ 'background-image': `url(/images/pages/home/regua/${item.id}.png)` }" />

              <a href="javascript:void(0)" @click="goToLevel(i);">
                <div><p>{{ item.nome }}</p></div>
              </a>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="emp-gallery -top" v-if="data.statusObra">
      <div class="container-title">
        <h2 class="-title">Status da Obra</h2>
      </div>

      <div class="container" v-if="data.statusObra && data.statusObra.fotos && data.statusObra.fotos.length">
        <div class="top-container">
          <div class="tabs">
            <p class="-active">
              <a href="javascript:void(0)" class="name">
                Empreendimento
                <span @click="toggleModal">{{ data.statusObra.fotos && data.statusObra.fotos.length || '0' }}</span>
              </a>
            </p>
          </div>
          <div class="status-date">
            <p>Fotos de {{ data.statusObra.mesReferenciaNome }} {{ data.statusObra.anoReferencia }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="slide-status" v-if="data.statusObra && data.statusObra.fotos && data.statusObra.fotos.length">
      <a href="javascript:void(0)" class="btn-carousel -prev" @click="prevStatus()" :class="{ '-deactivated': status.activeIndex == 0 }" v-if="isMobile"><i class="icon -arrow-left-red"></i></a>

      <div class="container">
        <swiper :options="status.options" ref="swiperStatus" @slideChange="slideChangedStatus()">
          <template>
            <swiper-slide v-for="(item, i) in data.statusObra.fotos" :key="i">
              <figure>
                <a href="javascript:void(0)" class="icon -zoom-white" @click="toggleModal"></a>

                <img :src="urlFiles + 'cliente/status-obra/' + item.foto" alt="">
              </figure>
            </swiper-slide>
          </template>
        </swiper>
      </div>

      <a href="javascript:void(0)" class="btn-carousel -next" @click="nextStatus()" :class="{ '-deactivated': status.activeIndex == data.statusObra.fotos.length - 1 }"><i class="icon -arrow-right-red"></i></a>
    </section>

    <section class="emp-gallery" v-if="data.statusObra && data.statusObra.fotos && data.statusObra.fotos.length">
      <div class="container">
        <div class="bottom-container">
          <ul>
            <li v-for="(item, index) in data.statusObra.fotos" :key="item.id" :class="{ '-active': index === status.activeIndex }" @click="slideToStatus(index)"></li>
          </ul>
        </div>
      </div>
    </section>

    <transition name="fade">
      <Modal :data="optsModal" @close="toggleModal()" v-if="optsModal.render" />
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'
import Modal from '@/components/Modal'

// 19 :: Acompanhamento da obra
// 59 :: Acompanhamento da obra
// 69 :: Acompanhamento da obra
// 79 :: Acompanhamento da obra
// 80 :: Acompanhamento da obra
// 81 :: Acompanhamento da obra
// 82 :: Acompanhamento da obra
// 26 :: Assembleia Geral de Instalação
// 62 :: Assembleia Geral de Instalação
// 27 :: Assistência Técnica
// 55 :: Assistência Técnica
// 24 :: Vistoria da unidade
// 58 :: Vistoria da unidade
// 25 :: Quitação do saldo devedor
// 60 :: Quitação do saldo devedor
// 54 :: Entrega das chaves
// 64 :: Entrega das chaves
// 18 :: Inicio da obra
// 57 :: Inicio da obra
// 67 :: Inicio da obra
// 22 :: Dia da medida
// 65 :: Dia da medida
// 52 :: Visita à obra
// 61 :: Visita à obra
// 01 :: Boas vindas
// 56 :: Boas vindas
// 68 :: Boas vindas
// 71 :: Emissão TVO

// 70 :: Conclusão da obra
// 72 :: Vistoria do lote
// 73 :: Assembleia Geral
// 74 :: Posse do lote

export default {
  name: 'home',

  components: {
    Modal
  },

  data () {
    const data = {
      loaded: false,

      optsModal: {
        type: 'GALLERY',
        urlBase: 'cliente/status-obra/',
        show: true,
        render: false,
        activeIndex: 0
      },

      data: {
        vitrines: [],

        regua: [],

        statusObra: {
          fotos: []
        }
      }, // data

      level: {
        options: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          // allowTouchMove: false,

          responsive: {
            0: {
              slidesPerView: 1,
              centeredSlides: true
              // spaceBetween: 20,
            },

            1200: {
              slidesPerView: 6,
              centeredSlides: false
              // spaceBetween: 20,
            }
          }
        },

        activeIndex: 0
      }, // level

      status: {
        options: {
          autoHeight: true
        },

        activeIndex: 0
      }, // status

      activeIndex: 0,

      urlFiles: Vue.prototype.urlFiles
    }

    return data
  }, // data()

  beforeMount () {
    this.loadPage()
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async loadPage () {
      let { empreendimentoIdWeb } = this.$store.state.contratoAtual

      try {
        const xhr = await PagesService.getHome(empreendimentoIdWeb)

        this.loaded = true

        if (xhr.statusObra) {
          this.optsModal.arr = xhr.statusObra.fotos || []
        }

        xhr.regua = xhr.regua.sort((a, b) => {
          const ordemA = a.ordem
          const ordemB = b.ordem
          if (ordemA > ordemB) return 1
          if (ordemA < ordemB) return -1

          return 0
        })

        const indexActive = xhr.regua.findIndex((item) => item.id === xhr.etapaReguaId)

        xhr.regua = xhr.regua.map((item, i) => ({
          ...item,
          isCompleted: i < indexActive,
          current: i === indexActive
        }))

        // Pegar index da regua
        const initialIndex = xhr.regua.findIndex((item) => (
          item.id === xhr.etapaReguaId
        ))

        this.data = xhr

        setTimeout(() => {
          if (initialIndex !== -1) {
            this.goToLevel(initialIndex)
          }
        }, 500)
      } catch (e) {
        console.error('Falha ao recuperar documentos', e)
      }
    }, // loadPage()

    slideChanged () {
      this.activeIndex = this.swiper.activeIndex
    }, // slideChanged()

    slideTo (i) {
      this.swiper.slideTo(i)
    }, // slideTo()

    slideToStatus (i) {
      this.swiperStatus.slideTo(i)
    }, // slideTo()

    goToLevel (i) {
      try { this.swiperLevel.slideTo(i) } catch (e) { /**/ }
    }, // goToLevel()

    slidePrevLevel () {
      this.swiperLevel.slidePrev()
    }, // slidePrevLevel()

    slideNextLevel () {
      this.swiperLevel.slideNext()
    }, // slideNextLevel()

    slideChangedStatus () {
      this.status.activeIndex = this.swiperStatus.activeIndex
      this.optsModal.activeIndex = this.status.activeIndex
    }, // slideChangedStatus()

    prevStatus () {
      this.swiperStatus.slidePrev()
    }, // prevStatus()

    nextStatus () {
      this.swiperStatus.slideNext()
    }, // nextStatus()

    isMobile () {
      return screen.width <= 1024
    }, // isMobile()

    toggleModal (i) {
      this.optsModal.render = !this.optsModal.render
    } // toggleModal()
  }, // methods

  computed: {
    swiper () {
      return this.$refs.swiperSlides.swiper
    }, // swiper()

    swiperLevel () {
      return this.$refs.swiperLevel.swiper
    }, // swiperLevel()

    swiperStatus () {
      return this.$refs.swiperStatus.swiper
    } // swiperStatus()
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .home-view
    background: #fff

  section
    &.slide-status
      .btn-carousel
        display: none

    &.slides
      background-color: #fff

      img
        display: block
        margin: 0 auto
        visibility: hidden
        min-height: 400px
        //max-height: 560px
        height: 515px
        // height: 300px
        // max-height: calc(100vh - 250px)

      .swiper-slide
        background-position: center
        background-repeat: no-repeat
        background-size: cover

      .bullets
        position: absolute
        bottom: 70px
        left: 50%
        transform: translateX(-50%)
        z-index: 10
        display: flex
        align-items: center
        justify-content: center

        a
          width: 20px
          height: 20px
          display: inline-block
          background-color: rgba(#fff, 0.2)
          margin: 0 7px
          transition: all 150ms ease

          &:hover,
          &.-active
            background-color: #fff

    &.emp-intro
      width: 100%
      height: 100vh
      position: relative

      .image-bg
        width: 100%
        height: 100%
        background-size: cover
        background-repeat: no-repeat
        background-position: center

      .container
        width: 100%
        height: calc(100vh - 186px)
        position: absolute
        z-index: 100
        right: 0
        bottom: 0
        left: 0

        .info
          top: 50%
          transform: translateY(-18%)
          position: absolute

          .box
            width: 100%
            max-width: 400px
            background-color: rgba(map-get($colors, primary), 0.65)
            padding: 40px 30px 20px 30px

            h1
              min-height: 100px
              color: #fff
              font-size: 35px
              display: flex
              font-weight: 600
              align-items: center
              justify-content: flex-start
              padding-right: 80px
              position: relative
              font-family: 'Gotham-Bold'
              margin-bottom: 10px;

              &:after
                content: ''
                background-image: url(~/images/icons/arrow-next.png)
                background-size: contain
                background-repeat: no-repeat
                background-position: center
                position: absolute
                width: 67px
                height: 89px
                top: 50%
                right: 0
                transform: translateY(-50%)

            p
              color: #fff
              font-size: 14px

    &.level
      width: 100%
      padding: 55px 0 80px
      background-color: #fff
      z-index: 10

      h2
        width: 100%
        font-family: 'Gotham-Bold'
        text-align: center
        font-weight: 400
        font-size: 25px
        line-height: 1
        color: #5b8991
        text-transform: uppercase
        transition: all 200ms ease
        margin-bottom: 30px

        &.-hide
          opacity: 0

      .swiper-content
        $size: 0
        position: relative
        width: 100%
        left: 0
        // width: calc(100% + #{$size * 1.3})
        // left: calc(#{$size * -1} / .8)
        top: 0

        .container
          position: relative
          padding: 0 65px

          /deep/ .swiper-wrapper > div:last-of-type
            margin-right: 0

          .nav-container
            width: 100%
            height: 100%
            position: absolute
            pointer-events: none
            left: 0
            top: 0
            z-index: 100

            a
              width: 50px
              height: calc(100% - 85px)
              position: absolute
              top: 50%
              transform: translateY(-50%)
              pointer-events: all
              transition: all 300ms ease
              opacity: .9
              background:
                position: center
                repeat: none

              &:hover
                opacity: 1

              &.-prev
                left: 0
                background-image:  url('~/images/icons/arrow-left-red-g.png')

              &.-next
                right: 0
                background-image:  url('~/images/icons/arrow-right-red-g.png')

              &.-deactivated
                pointer-events: none
                opacity: .5

          .swiper-container
            padding: 30px 0 !important

          .phases
            width: 100%
            position: absolute
            bottom: 9px
            z-index: 1000

            ul
              display: flex
              padding: 0 0 0 74px

              @media (max-width: 1024px)
                padding: 0 0 0 87px

              li
                $size: 25px
                width: $size
                height: $size
                flex: 0 0 $size
                border: 4px solid #000
                background-color: map-get($colors, primary)
                border-radius: 100%
                position: relative
                z-index: 1000
                margin-right: 168px

                @media (max-width: 1024px)
                  margin-right: 179px

                &:after
                  content: ''
                  width: 190px
                  height: 6px
                  background-color: #4f4f4f
                  position: absolute
                  left: calc(100% + 3px)
                  top: 50%
                  transform: translateY(-50%)
                  pointer-events: none

                &:last-child
                  &:after
                    display: none

                span
                  font-family: 'Gotham-Bold'
                  position: absolute
                  color: #000
                  font-size: 12px
                  font-weight: 600
                  text-transform: uppercase
                  top: calc(100% + 17px)
                  left: 50%
                  padding-left: 17px
                  transform: translateX(-50%)
                  z-index: 1
                  white-space: nowrap

                  &:before
                    content: ''
                    position: absolute
                    left: 0
                    top: 0
                    width: 12px
                    height: 12px
                    border-left: 3px solid #4f4f4f
                    border-bottom: 3px solid #4f4f4f

                &.phase-done
                  background-color: #8c8c8c

                &.current-phase
                  background-color: #fff

          .-slide
            width: 176px
            height: 250px
            margin-right: 16px
            overflow: hidden
            transition: all 250ms ease
            // cursor: pointer
            position: relative
            border: 3px solid #4f4f4f

            .step-image
              position: absolute
              left: 0
              top: 0
              right: 0
              bottom: 0
              background-repeat: no-repeat
              background-position: top right
              background-color: #fff
              background-size: contain
              width: 100%
              height: 100%

            &.-current-phase
              background-color: map-get($colors, primary) !important
              transform: scale(1.08)

              div
                p
                  color: #fff

              &:before
                border-color: #ff4e59

            &.-phase-done
              background-color: #fff
              opacity: 0.3

            // &.swiper-slide-active
            //   background-color: map-get($colors, primary) !important
            //   transform: scale(1.08)

            //   div
            //     p
            //       color: #fff

            //   &:before
            //     border-color: #ff4e59

            &:before,
            &:after
              content: ''
              position: absolute
              top: 0
              right: 0
              bottom: 0
              left: 0
              width: 100%
              height: 100%
              transition: all 250ms ease

            &:before
              border: 6px solid transparent
              z-index: 10

            &:after
              z-index: 0
              opacity: 1
              background-repeat: no-repeat
              background-position: top right

            a
              position: absolute
              right: 0
              left: 0
              width: 100%
              display: flex
              justify-content: center
              text-align: center
              z-index: 100
              pointer-events: none
              background: #fff
              top: 62%
              color: #5b8991
              bottom: 0
              height: auto
              border-top: 1px solid #4f4f4f
              padding: 15px 5px 0px 5px
              align-items: flex-start

              div
                height: auto
                display: flex
                align-items: center
                justify-content: center

                p
                  font-family: 'Gotham-Bold'
                  color: #5b8991
                  font-weight: 400
                  text-align: center
                  text-transform: uppercase
                  font-size: 14px
                  line-height: 17px

      .pagination
        left: 50%
        transform: translateX(-50%)
        position: relative
        display: flex
        justify-content: space-between
        align-items: center
        width: 180px

        .btn-container
          position: relative
          width: 40px
          height: 60px

          a
            position: absolute
            top: 0
            right: 0
            bottom: 0
            left: 0
            width: 100%
            height: 100%
            transition: all 150ms ease

            &.-hide
              opacity: 0

            &.-arrow-left-white,
            &.-arrow-right-white
              opacity: 0.2

            &.-deactivated
              pointer-events: none

        p
          color: #fff
          font-weight: 600
          text-align: center
          text-transform: uppercase
          font-size: 18px
          letter-spacing: 1px

    &.emp-gallery
      margin: 0 auto
      padding: 60px 0
      overflow: hidden
      position: relative

      &.-top
        padding: 60px 0 0

      .container
        position: relative

        .swiper-content
          position: relative

        .top-container
          padding: 0
          pointer-events: none
          display: flex
          justify-content: space-between
          align-items: center

          &:before
            content: ''
            width: 100%
            height: 100%
            position: absolute
            z-index: -1
            bottom: 0
            left: 0
            pointer-events: none

          .tabs
            display: flex
            align-items: center
            justify-content: flex-start

            p
              text-transform: uppercase
              color: #000
              cursor: pointer
              pointer-events: all
              position: relative
              padding: 5px 10px 5px 35px

              *,
              *:after,
              *:before
                // transition: all 200ms ease

              &.-active,
              &:hover
                border-color: transparent
                background: map-get($colors, primary)

                a
                  color: #fff

                  &:after
                    opacity: 1

              a
                font-size: 25px
                font-weight: 500
                display: inline-block

                &:after
                  content: ''
                  position: absolute
                  left: 100%
                  top: 0
                  width: 0
                  height: 0
                  // transition: all 90ms ease
                  border-top: 44px solid map-get($colors, primary)
                  opacity: 0
                  border-right: 35px solid transparent

                span
                  position: relative
                  top: -3px
                  font-size: 14px
                  font-weight: 500
                  background-color: #fff
                  color: map-get($colors, primary)
                  padding: 5px 11px 3px
                  border-radius: 100px
                  margin-left: 5px

                  &:before
                    content: ''
                    display: inline-block
                    background-image: url(~/images/icons/foto.png)
                    background-repeat: no-repeat
                    background-size: contain
                    background-position: center
                    width: 18px
                    height: 14px
                    top: 2px
                    margin-right: 5px
                    position: relative

                  span
                    position: relative
                    top: -2px

          .status-date
            p
              text-transform: uppercase

        .bottom-container
          position: absolute
          right: 0
          left: 0
          bottom: 0
          pointer-events: none
          text-align: center
          z-index: 100
          padding: 0

          .caption
            right: 0
            bottom: 0
            position: absolute
            padding: 10px
            text-transform: uppercase
            color: #fff
            font-weight: 600
            background-color: rgba(#000, .5)

          ul
            display: inline-block
            // border-bottom: 2px solid  #fff
            // padding-bottom: 5px
            // margin-bottom: 25px
            min-height: 27px
            position: relative
            bottom: 20px

            li
              display: inline-block
              width: 11px
              height: 11px
              margin-right: 7px
              background: #ccc
              cursor: pointer
              transition: all 200ms ease
              pointer-events: all

              &:last-of-type
                margin-right: 0

              &:hover,
              &.-active
                background: map-get($colors, primary)
                height: 11px

          .full
            width: 100%
            display: block

          a
            background: rgba(#000, 0.25)
            color: #fff
            text-transform: uppercase
            padding: 10px 20px 5px
            border: 2px solid #fff
            font-weight: 500
            font-size: 18px
            transition: all 100ms ease
            pointer-events: all

            &:hover
              background: rgba(#000, 0.5)

    @media (max-width: 1024px)
      &.emp-intro
        height: 200px
        position: relative

        .container
          width: 100%
          height: 100%
          display: flex
          align-items: center

          .info
            transform: translateY(0)
            position: static

            .box
              width: 100%
              max-width: 400px
              background-color: rgba(map-get($colors, primary), 0.65)
              padding: 20px 15px 10px

              h1
                min-height: 100px
                color: #fff
                font-size: 28px
                display: flex
                font-weight: 600
                align-items: center
                justify-content: flex-start
                padding-right: 60px
                position: relative
                font-family: 'Gotham-Bold'
                margin-bottom: 10px;

                &:after
                  width: 53px
                  height: 65px
                  transform: translateY(-50%)

              p
                font-size: 11px

      &.slides
        img
          visibility: visible
          height: auto

        .swiper-slide
          background-image: none !important

        .bullets
          bottom: 20px

          a
            width: 15px
            height: 15px
            margin: 0 3px

      &.level
        padding-top: 25px
        padding-bottom: 0

        h2
          margin-bottom: 0

        .swiper-content
          margin-top: 0 !important

          .container
            padding: 0 !important

            .nav-container
              display: none

            .swiper-container
              &:after
                display: none

        .pagination
          margin-top: 25px
          left: 50%

        h2
          position: relative
          left: initial
          transform: translateX(0)
          top: initial
          display: block
          text-align: center
          font-size: 26px

        .swiper-content
          width: 100%
          left: 0%
          margin-top: 35px
          top: initial

          .-slide
            border-width: 5px
            margin: 0 10px

      &.slide-status
        position: relative

        .btn-carousel
          display: block !important

        &:before
          width: 100%
          display: block
          text-align: center
          content: 'Status da Obra'
          font-family: 'Gotham-Bold'
          color: #fff
          font-size: 20px
          text-transform: uppercase
          position: absolute
          top: 10px
          left: 0
          z-index: 100

        .container
          padding: 0

          .icon
            opacity: 1;

            &.-zoom-white
              background-size: 34px
              background-color: rgba(0, 0, 0, 0.5)

      &.emp-gallery
        padding: 0 !important

        &.-top
          .container-title
            display: none

        &:last-child
          display: none

        &.-top
          padding: 60px 0 0

        .container
          position: relative

          .swiper-content
            position: relative

          .top-container
            display: none

            &:before
              content: ''
              width: 100%
              height: 100%
              position: absolute
              z-index: -1
              bottom: 0
              left: 0
              pointer-events: none

</style>
